









































































































import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";

import JConfTableV01 from "@share/common/tables/j-conf-table/virtual/JConfTable-V01.vue";
import TicketsSelectFilters from "@share/committees/committee-form/steps/step-2-tickets-select/filters/TicketsSelectsFilters.vue"
import CheckboxControl from "@share/common/controls/checkbox/Checkbox.vue";
import UserProfileCollector from "@share/committees/common/service-components/UserProfilesCollector.vue";
import TicketStatusIcon from "@share/committees/common/components/TicketStatusIcon.vue";
import Paginatable from "@share/common/service-components/pagination/Paginatable.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";
import Overlay from "@share/common/Overlay.vue";
import TableArrows from "@share/common/table-arrows/TableArrows.vue";
import TicketTitle from "./components/TicketTitle.vue";

import { TicketsListService } from "@share/common/services/ticket/list/TicketsListService";
import { HeaderSetting, TableClasses, TableSettings } from "@share/common/tables/j-conf-table/types";
import { TicketService } from "@share/common/services/ticket/TicketService";
import { TableHelperInterface } from "@common/table/interfaces/TableHelper";
import { TicketTableHelper } from "@share/ticketSystem/helpers/TicketTableHelper";
import { getIsTicketAdmin } from "@share/common/helpers/ticketSystemHelpers";
import { getDefaultManualFilterState } from "@share/committees/committee-form/steps/step-2-tickets-select/data";
import { TicketsListQueryHelper } from "@share/common/services/ticket/list/TicketsListQueryHelper";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { TicketsListFilterState } from "@share/common/services/ticket/list/TicketsListFilterState";
import { TicketType } from "@share/ticketSystem/enums/TicketTypes";
import { UserProfileService } from "@share/common/services/dataLoading/userProfiles/UserProfilesService";
import { dateToFormatFromIso } from "@common/dateTimeHelper";
import { FilterSetting } from "@common/table/interfaces/FilterSetting";
import { Debounce } from "vue-debounce-decorator";

import { TicketRowInterfaceForm } from "@share/committees/common/types/interfaces/TicketsRowInterface";
import { TableRowModelForm } from "@share/committees/common/types/models/TicketsTableRowModel";

@Component({ components: { JConfTableV01, CheckboxControl, TicketsSelectFilters, BounceSpinner, Overlay, TableArrows, TicketStatusIcon, TicketTitle } })

export default class Step2TicketsSelect extends Mixins(UserProfileCollector, Paginatable) {

    @Prop({}) selectedTicketsIds: string[];
    @Prop({ required: true }) subjectType: TicketType;

    private _allIsSelected = false;

    tableSettings: TableSettings = {minRowHeight: 76}

    filters: FilterSetting[] = [];

    filterState: TicketsListFilterState = {
        type: TicketType.idea
    }

    filterSelectedTickets = false;

    list: TicketRowInterfaceForm[] = [];

    ticketListService: TicketsListService<TicketRowInterfaceForm>;
    ticketService: TicketService;
    ticketHelper: TableHelperInterface;

    tableClasses: TableClasses = {
        header: "step-2-subject-select__table-header",
        body: "step-2-subject-select__table-body",
        row: "step-2-subject-select__table-row"
    }

    created() {

        this.filterState = {
            type: this.subjectType,
            isOnlyAssignedForMe: false,
            keyword: "",
            orderDirection: "asc",
            sortedField: "",
            ...getDefaultManualFilterState()
        }

        this.ticketListService = new TicketsListService(
            new TicketsListQueryHelper(this.userId, this.pagingState),
            this.$repositories.get(RepositoryFabric.TICKET)
        );

        this.userProfileService = new UserProfileService(
            this.$repositories.get(RepositoryFabric.USER),
            ["id", "userId", "lastName", "firstName", "middleName", "company", "position", "photoFileId"]
        );

        this.ticketService = new TicketService(this.$store, this.isTicketAdmin);
        this.ticketHelper = Vue.observable(new TicketTableHelper(this.ticketService, this.subjectType, this.$store));

        this.updateList();

        this.ticketHelper.getFilterList()
        .then(data => {
            this.filters = data;
        })
    }

    async updateList(reset = false) {

        if(reset) {
            this.resetPagination();
        }

        if (this.isTheFirstPage) {
            this.pagingState.skip = 0;
            this.list = [];
        }

        try {
            this.isLoading = true;
            this.pagingState.skip = this.list.length;

            const rawList = await this.ticketListService.load(this.filterState);
            const selectedTicketsIdsSet = new Set(this.selectedTicketsIds);

            // LIST:
            let list = this.selectedTicketsIds.length ?
                rawList.map((item) => new TableRowModelForm(item, selectedTicketsIdsSet.has(item.id)))
                :
                rawList.map((item) => new TableRowModelForm(item))

            this.list = this.isTheFirstPage ? list : this.list.concat(list);

            // USERS:
            const userIds = rawList.map((item) => [...item.ownerIds, item.responsibleUserId]).flat().filter(x => x);
            this.updateUsersProfilesList(userIds);
        }
        catch(e) {
            this.$store.dispatch("reportError", e);
        }
        finally {
            this.isLoading = false;
        }
    }

    open(ticket: TicketRowInterfaceForm) {
        this.$emit('open', ticket)
    }

    filter(reset = false) {
        this.updateList(reset);
    }

    resetFilter() {
        this.filterState = {
            ...this.filterState,
            ...getDefaultManualFilterState()
        }

        this.updateList(true);
    }

    @Debounce(200)
    sort(sortedField: string) {
        this.filterState.orderDirection = this.filterState.orderDirection === "asc" ? "desc" : "asc";
        this.filterState.sortedField = sortedField;
        this.updateList();
    }

    onBottomHandler() {
        if(this.turnOverPageIfNeed(this.ticketsList.length)) {
            this.updateList();
        }
    }

    setSelectedFiltering(value: boolean) {
        this.filterSelectedTickets = value;
    }

    getFormatedDate(dateString: string) {
        return dateToFormatFromIso(dateString, "dd.LL.yyyy");
    }

    allCheckboxInput(selected: boolean) {
        if(selected) {
            this.$emit("update", this.list.map(item => item.id))
        }
        else {
            this.$emit("update", [])
        }
    }

    checkboxInput(id: string, selected: boolean) {
        if(selected) {
            this.$emit('update', [...this.selectedTicketsIds, id])
        }
        else {
            this.$emit('update', this.selectedTicketsIds.filter(selectedId => selectedId !== id))
        }
    }

    @Watch("selectedTicketsIds")
    watchSelectedTicketsIds(selectedTicketsIds: Set<string>) {
        const selected = new Set(selectedTicketsIds);

        this.list.forEach((item) => {
            item.selected = selected.has(item.id)
        })
    }

    get ticketsList() {
        return this.filterSelectedTickets ? this.list.filter((ticket) => ticket.selected) : this.list;
    }

    get headerSettings(): HeaderSetting[] {
        return [
            {
                title: this.$t(`tickets.columns.${this.subjectType}`).toString(),
                name: 'subject'
            },
            {
                title: this.$t("tickets.columns.category").toString(),
                name: 'category'
            },
            {   title: this.$t("tickets.columns.status").toString(),
                name: "status"
            },
            {   title: this.$t("tickets.columns.company").toString(),
                name: "company"
            },
            {   title: this.$t("tickets.columns.responsibleUserId").toString(),
                name: "responsibleUser"
            },
            {   title: this.$t("tickets.columns.dateOfSubmission").toString(),
                name: "createdAt"
            },
            {   title: this.$t("tickets.columns.implementationDate").toString(),
                name: "implementedAt"
            },
        ]
    }

    get isTicketAdmin() {
        return getIsTicketAdmin(this.$route?.name, this.$store.getters["groupIds"], this.subjectType)
    }

    get allIsSelected() {
        return this.list.every(item => item.selected) && this._allIsSelected
    }

    set allIsSelected(value: boolean) {
        this.list.forEach(item => item.selected = value);
        this._allIsSelected = value;
    }

    get selectedTicketsCount() {
        return this.selectedTickets.length;
    }

    get selectedTickets() {
        return this.list.filter((items) => items.selected);
    }

    get indeterminate() {
        return this.list.some(item => item.selected)
    }

    get userId() {
        return this.$store.state.session.userId;
    }
}

